import { Action, ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as UserAccountsReducer from './user-accounts.reducer';

export interface UserAccountsState {
  userAccounts: UserAccountsReducer.State;
}

export interface State extends fromRoot.State {
  userAccountsState: UserAccountsState;
}

export const reducers: ActionReducerMap<UserAccountsState, Action> = {
  userAccounts: UserAccountsReducer.reducer,
};

export const selectUserAccounts = createFeatureSelector<State, UserAccountsState>('userAccountsState');

export const selectUserAccountsState = createSelector(selectUserAccounts, (state: UserAccountsState) => state.userAccounts);

export const getUserAccounts = createSelector(selectUserAccountsState, UserAccountsReducer.getUserAccounts);
